import { useDisclosure } from "hooks/useDisclosure";
import { firestoreActions } from "modules/firestore";
import { liveActions } from "modules/live";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "store";
import { getLiveContextType } from "utility/live";

import type { EventVideo } from "@spwn/types/firebase/firestore";
import type { Store } from "store";

export const useLiveEvent = (currentVideo: EventVideo | undefined) => {
  const dispatch = useDispatch();
  const {
    isOpen: isOpenLiveEvent,
    onOpen: handleOpenLiveEvent,
    onClose: handleCloseLiveEvent,
    onToggle: handleToggleLiveEvent,
  } = useDisclosure();

  const isAdmin = useSelector((state: Store) => state.admin.isAdmin);
  const eventInfo = useSelector((state: Store) => state.event.displayEvent);
  const contextId = useSelector((state: Store) => state.live.contextId);
  const contextType = getLiveContextType(contextId);

  const isLiveEventEnabled =
    isAdmin ||
    ((eventInfo.streamingInfo?.commentTab.isLiveEventEnabled ?? false) &&
      (currentVideo?.isLiveEventEnabled === undefined ||
        currentVideo.isLiveEventEnabled));

  const watchEventInfo = () => {
    dispatch(liveActions.watchEventContext.started({ eventId: eventInfo._id }));
    return () => {
      dispatch(firestoreActions.closeChannel({ channel: "liveContext" }));
    };
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(watchEventInfo, [eventInfo]);

  useEffect(() => {
    if (contextType) {
      handleOpenLiveEvent();
    }
  }, [contextType, handleOpenLiveEvent]);

  return {
    isLiveEventEnabled,
    isOpenLiveEvent: isOpenLiveEvent && isLiveEventEnabled,
    handleCloseLiveEvent,
    handleToggleLiveEvent,
  };
};
